export default __webpack_public_path__ + "static/media/BookingToolBlockReservationDesktop.93cac3c8.png";